import React from 'react'
import classnames from 'classnames'

const CopyToClipboard = ({className, ...otherProps}) => (
  <svg viewBox="0 0 32 32" className={classnames('Icpon', className)} {...otherProps}>
    <path
      d="M10 24.5v1H8.5A1.5 1.5 0 0 1 7 24V8a1.5 1.5 0 0 1 1.5-1.5h3.087a3.251 3.251 0 0 1 6.326 0H21A1.5 1.5 0 0 1 22.5 8v2h-1V8a.5.5 0 0 0-.5-.5H16.986a2.25 2.25 0 1 0-4.473 0H8.5A.5.5 0 0 0 8 8v16a.5.5 0 0 0 .5.5H10zm4.75-16a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm0-.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5zm-1.522 4.25a.48.48 0 0 0-.478.483v13.534a.48.48 0 0 0 .478.483h10.044a.48.48 0 0 0 .478-.483V12.733a.48.48 0 0 0-.478-.483H13.228zM13 11h10.5a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5H13a1.5 1.5 0 0 1-1.5-1.5v-14A1.5 1.5 0 0 1 13 11z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

export default CopyToClipboard;
